import { expressEventListener, expressQuerySelector } from "../../common/html";
import { compositeDisposable, IDisposable } from "../../utils/disposable";
import { getPhotoDetails } from "../../services/myphotos-service";

export interface IDetailedPhotoInfoDependencies {
	readonly onClose: () => void;
}

export interface IDetailedPhotoInfo {
	readonly update: (photoId: string) => void;
}
export function createDetailedPhotoInfo(
	containerEl: HTMLElement,
	photoId: string,
	albumName: string,
	deps: IDetailedPhotoInfoDependencies,
) {
	const { onClose } = deps;
	const closeButtonEl = expressQuerySelector<HTMLElement>(containerEl, ".technical-photo-details-close", true);
	const fileNameEl = expressQuerySelector<HTMLElement>(containerEl, ".technical-filename", true);
	const fileSizeEl = expressQuerySelector<HTMLElement>(containerEl, ".technical-filesize", true);
	const resolutionEl = expressQuerySelector<HTMLElement>(containerEl, ".technical-resolution", true);
	const dateTakenEl = expressQuerySelector<HTMLElement>(containerEl, ".technical-datetaken", true);
	const albumEl = expressQuerySelector<HTMLElement>(containerEl, ".technical-album", true);
	const dateAddedEl = expressQuerySelector<HTMLElement>(containerEl, ".technical-dateadded", true);
	const modifiedEl = expressQuerySelector<HTMLElement>(containerEl, ".technical-modified", true);
	let disposable: IDisposable;
	const onCloseEvent = () => {
		fileNameEl.innerText = "-";
		fileSizeEl.innerText = "-";
		resolutionEl.innerText = "-";
		dateTakenEl.innerText = "-";
		albumEl.innerHTML = "-";
		dateAddedEl.innerText = "-";
		modifiedEl.innerText = "-";
		disposable.dispose();
		onClose();
	};

	getPhotoDetails(photoId).then((res) => {
		if (res) {
			fileNameEl.innerText = res.fileName;
			fileSizeEl.innerText = res.fileSize + "";
			resolutionEl.innerText = res.resolution;
			dateTakenEl.innerText = res.dateTaken;
			albumEl.innerHTML = res.album || albumName;
			dateAddedEl.innerText = res.dateAdded;
			modifiedEl.innerText = res.modified;
		}
		disposable = compositeDisposable([expressEventListener(closeButtonEl, "click", onCloseEvent)]);
	});

	const update = (photoId: string) => {
		getPhotoDetails(photoId).then((res) => {
			if (res) {
				fileNameEl.innerText = res.fileName;
				fileSizeEl.innerText = res.fileSize + "";
				resolutionEl.innerText = res.resolution;
				dateTakenEl.innerText = res.dateTaken;
				albumEl.innerHTML = res.album || albumName;
				dateAddedEl.innerText = res.dateAdded;
				modifiedEl.innerText = res.modified;
			}
		});
	};

	return {
		update,
	} as IDetailedPhotoInfo;
}
